<div class="card row"
    [class.selected]="selected"
    (click)="toggleSelected()">
  <i class="fa"
    [class.fa-clock-o]="type === 'Time'"
    [class.fa-refresh]="type === 'Cycle'"
    [class.fa-undo]="type === 'Return'"
    [class.fa-asterisk]="type === 'On Demand'"
  ></i>
  <p class="name">{{recurrence.name}}</p>
  <span class="row">
    <p>{{'admin.toolMaintenancePlans.recurrences.recurringEvery' | translate}}</p>
    <strong>{{type === 'Return' || type === 'On Demand' ? '' : recurrence.value}}{{(type === 'Time' ? unit : type) | lowercase}}</strong>
  </span>
</div>
